import { useEffect } from "react";

import { chatStore } from "@/store/chat";
import { threadStore } from "@/store/thread";

export function useThreadSession(threadId: string) {
  useEffect(() => {
    if (!threadId) {
      threadStore.clearThread();
      return;
    }

    threadStore.setThreadId(threadId);
    chatStore.setThreadId(threadId);

    return () => {
      threadStore.clearThread();
      chatStore.clearThread();
    };
  }, [threadId]);
}
